import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export class BreadcrumbItem extends PureComponent {
  render() {
    const itemClasses = ['breadcrumb-anchor'];

    const {
      onClick,
      href,
      text,
      name,
    } = this.props;
    const clickableStaticElementProps = !_.isUndefined(onClick)
      ? {
        onClick,
        onKeyDown: onClick,
        role: 'link',
        tabIndex: 0,
      }
      : {};

    return (
      <li className="breadcrumb-item" data-item-name={name}>
        { !_.isUndefined(href)
          ? <a href={href} className={itemClasses} onClick={onClick}>{text}</a>
          : <span className={itemClasses} {...clickableStaticElementProps}>{text}</span>
        }
      </li>
    );
  }
}

BreadcrumbItem.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

BreadcrumbItem.defaultProps = {
  href: undefined,
  onClick: undefined,
};
